import { FormControl } from '@angular/forms';
import { ICustomFile } from '@shared/components/file-uploader/file-uploader.interface';

export enum EBugReportType {
  bug = 'bug',
  feedback = 'feedback',
  contact = 'contact',
}

export enum EBugReportStatus {
  new = 'new',
  open = 'open',
  done = 'done',
}

export interface IBugReport {
  id?: string;
  type: EBugReportType;
  status: EBugReportStatus;
  imageId: string | null;
  currentUrl: string;
  browserInfo: string;
  screenResolution: string;
  message: string;
  createdAt?: string;
  createdAtDate?: Date | null;
  createdBy?: string | null;
  userGroupId?: string | null;
}

export interface IBugReportDialogData {
  type?: EBugReportType;
  imageId?: string | null;
}

export interface IBugReportDialogFormValue {
  message: string;
  type: EBugReportType;
}

export interface IBugReportDialogForm {
  message: FormControl<string>;
  type: FormControl<EBugReportType>;
  imageFile: FormControl<ICustomFile | null>;
}
